var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class HomeScreen extends Component {
    constructor() {
        super('HomeScreen', true);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.component-homescreen').on('click', () => {
                this.hide();
            });
            if (sessionStorage.getItem('homescreen-shown') === 'true') {
                $('.component-homescreen').remove();
            }
            else {
                sessionStorage.setItem('homescreen-shown', 'true');
                setTimeout(() => {
                    this.hide();
                }, 750);
            }
            this.success();
        });
    }
    hide() {
        $('.component-homescreen').addClass('fade-out');
        setTimeout(() => {
            $('.component-homescreen').remove();
        }, 3000);
    }
}
